import React from "react";
import { Box, Grid, Button, Input, TextField, Select, MenuItem, FormControl, IconButton, useTheme, InputLabel, Typography, Paper, Collapse, InputAdornment } from "@mui/material";
import { Formik, FieldArray, Form } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from "react";
import { tokens } from "../../../theme"
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useAddOrganizationS3ConfigMutation, useGetOrganizationsQuery } from "../../../features/organizations/organizationsApiSlice";







const S3Config = () => {

  const params = useParams()
  const organization_id = params.organization_id
  console.log("Organization ID: ", params.organization_id)


  const { organization } = useGetOrganizationsQuery("organizations", {
    selectFromResult: ({ data }) => ({
      organization: data?.entities[organization_id]
    }),
  })

  const [updateOrganizationS3Config, {
    isLoading,
    isSuccess,
    isError,
    error
  }] = useAddOrganizationS3ConfigMutation();

  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);


  const handleFormSubmit = async (id, s3Config) => {
    try {
      console.log("S3 Config:", s3Config);
      const { data } = await updateOrganizationS3Config({ id, s3Config }); // Call the updateOrganizationS3Config mutation

      console.log("Response data:", data);
      console.log("Successfully updated the S3 configuration.");
      //navigate('/');
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const [isSnowflakeOpen, setSnowflakeOpen] = useState(true);
  const [isForeignS3Open, setIsForeignS3Open] = useState(true);
  const [isOnpremiseS3Open, setIsOnpremiseS3Open] = useState(true);
  const [showAccessKey, setShowAccessKey] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState(false);


  const cleanedName = organization?.name.toLowerCase().replace(/\s/g, "-");
  // Initialize form values
  const initialValues = {
    recipient_emails: [],
    provisioning_type: [],
    infra_data: {
      onprem_config: {
        s3_uri: "",
        onprem_bucket: 'trovo-coop-' + cleanedName,
        disableACL: false,
        foreign_aws_id: "",
        snowflake_storage_integration: "",
        bucket_location: "us-west-2",
        onprem_service_users: [],
        foreign_service_users: []
      },
      foreign_config: {
        s3_uri: "",
        foreign_aws_id: "",
        foreign_bucket: "",
        trovo_access: false,
        aws_access_key_id: "",
        aws_secret_access_key: "",
        snowflake_storage_integration: "",
        bucket_location: "us-west-2",
      },
      snowflake_config: {
        organization: "",
        locator: "",
        sf_region: "",
      },
    }
  };



  // Add handler functions
  const handleToggleForeignS3 = () => {
    setIsForeignS3Open(!isForeignS3Open);
  };

  const handleToggleOnpremiseS3 = () => {
    setIsOnpremiseS3Open(!isOnpremiseS3Open);
  };

  const handleToggleSnowflake = () => {
    setSnowflakeOpen(!isSnowflakeOpen);
  };

  return (
    <Box m="20px" maxWidth="80%">
      <Typography component="div" variant="h4">Delivery Configuration</Typography>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleFormSubmit(organization_id, values)}
      //validationSchema={validationSchema}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <FieldArray name="recipient_emails">
                {({ push, remove }) => (
                  <Box>
                    <Typography component="div" variant="h6">Recipient Emails</Typography>
                    {values.recipient_emails.map((email, index) => (
                      <Box key={index} display="flex" alignItems="center" mb={2}>
                        <TextField
                          fullWidth
                          variant="filled"
                          type="text"
                          label="Email"
                          name={`recipient_emails.${index}`}
                          value={email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.recipient_emails && errors.recipient_emails[index] && touched.recipient_emails && touched.recipient_emails[index]}
                          helperText={errors.recipient_emails && errors.recipient_emails[index] && touched.recipient_emails && touched.recipient_emails[index] ? errors.recipient_emails[index] : null}
                        />
                        <Button
                          variant="outlined"
                          style={{ color: '#f44336', borderColor: '#f44336' }}
                          onClick={() => remove(index)}
                        >
                          Delete
                        </Button>
                      </Box>
                    ))}
                    <Button variant="outlined" color="secondary" onClick={() => push("")}>
                      <Box component="span" fontSize="20px">+</Box> Add Email
                    </Button>
                  </Box>
                )}
              </FieldArray>

              <Typography variant="body1">
                For multiple provisioning types, fill out each form individually before selecing Submit.
              </Typography>

              <FormControl fullWidth variant="filled">
                <InputLabel htmlFor="provisioning_type">Provisioning Type</InputLabel>
                <Select
                  multiple
                  id="provisioning_type"
                  name="provisioning_type"
                  value={values.provisioning_type}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="Provisioning Type"
                >
                  <MenuItem value="snowflake">Snowflake</MenuItem>
                  <MenuItem value="foreign_s3">Foreign S3 (EXPERIMENTAL)</MenuItem>
                  <MenuItem value="onpremise_s3">Onpremise S3 (EXPERIMENTAL)</MenuItem>
                </Select>
                {errors.provisioning_type && touched.provisioning_type ? <span>{errors.provisioning_type}</span> : null}
              </FormControl>
              {/* Conditionally render fields based on provisioning_type value */}
              {
                values.provisioning_type.includes("foreign_s3") && (
                  <Paper>
                    <Box mt={2}>
                      <Button fullWidth style={{ color: 'white' }} onClick={handleToggleForeignS3}>
                        <Typography component="div" variant="h6">
                          {isForeignS3Open ? "Foreign S3 Config (-)" : "Foreign S3 Config (+)"}
                        </Typography>
                      </Button>
                    </Box>
                    <Collapse in={isForeignS3Open}>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Foreign Bucket ARN"
                              name="infra_data.foreign_config.foreign_bucket_arn"
                              value={values.infra_data.foreign_config.foreign_bucket_arn}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Foreign AWS Account ID"
                              name="infra_data.foreign_config.foreign_aws_id"
                              value={values.infra_data.foreign_config.foreign_aws_id}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Foreign S3 URI"
                              name="infra_data.foreign_config.s3_uri"
                              value={values.infra_data.foreign_config.s3_uri}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box m={2}>
                            <FormControl fullWidth variant="filled">
                              <InputLabel htmlFor="bucket_location">Bucket Region</InputLabel>
                              <Select
                                id="bucket_location"
                                name="infra_data.foreign_config.bucket_location"
                                value={values.infra_data.foreign_config.bucket_location}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Bucket Region"
                              >
                                <MenuItem value="us-east-2">US East 2</MenuItem>
                                <MenuItem value="us-east-1">US East 1</MenuItem>
                                <MenuItem value="us-west-2">US West 2</MenuItem>
                                <MenuItem value="us-west-1">US West 1</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box m={2}>
                            <FormControl fullWidth variant="filled">
                              <InputLabel htmlFor="trovo_access_type">Trovo Access Type</InputLabel>
                              <Select
                                id="trovo_access_type"
                                name="infra_data.foreign_config.trovo_access_type"
                                value={values.infra_data.foreign_config.trovo_access_type}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label="Trovo Access Type"
                              >
                                <MenuItem value="service_user">Service User</MenuItem>
                                <MenuItem value="bucket_access">Bucket Access</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>

                        {values.infra_data.foreign_config.trovo_access_type === "service_user" && (
                          <>
                            <Grid item xs={4}>
                              <Box m={2}>
                                <FormControl fullWidth variant="filled">
                                  <InputLabel htmlFor="aws_access_key_id">AWS Access Key ID</InputLabel>
                                  <Input
                                    id="aws_access_key_id"
                                    type={showAccessKey ? 'text' : 'password'}
                                    value={values.infra_data.foreign_config.aws_access_key_id}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={() => setShowAccessKey(!showAccessKey)}
                                          edge="end"
                                        >
                                          {showAccessKey ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box m={2}>
                                <FormControl fullWidth variant="filled">
                                  <InputLabel htmlFor="aws_secret_access_key">AWS Secret Access Key</InputLabel>
                                  <Input
                                    id="aws_secret_access_key"
                                    type={showSecretKey ? 'text' : 'password'}
                                    name="infra_data.foreign_config.aws_secret_access_key"
                                    value={values.infra_data.foreign_config.aws_secret_access_key}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={() => setShowSecretKey(!showSecretKey)}
                                          edge="end"
                                        >
                                          {showSecretKey ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Box>
                            </Grid>
                          </>
                        )}
                      </Grid>
                    </Collapse>
                  </Paper>
                )
              }

              {
                values.provisioning_type.includes("snowflake") && (
                  <Paper>
                    <Box mt={2}>
                      <Button fullWidth style={{ color: 'white' }} onClick={handleToggleSnowflake}>
                        <Typography component="div" variant="h6">
                          {isSnowflakeOpen ? "Snowflake (-)" : "Snowflake (+)"}
                        </Typography>
                      </Button>
                    </Box>
                    <Collapse in={isSnowflakeOpen}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Organization"
                              name="infra_data.snowflake_config.organization"
                              value={values.infra_data.snowflake_config.organization}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Locator"
                              name="infra_data.snowflake_config.locator"
                              value={values.infra_data.snowflake_config.locator}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12}>
                          <Box m={2}>
                            <TextField
                              fullWidth
                              variant="filled"
                              type="text"
                              label="Region"
                              name="infra_data.snowflake_config.sf_region"
                              value={values.infra_data.snowflake_config.sf_region}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Collapse>
                  </Paper>
                )
              }

              {
                values.provisioning_type.includes("onpremise_s3") && (
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <Paper>
                        <Box mt={2}>
                          <Button fullWidth style={{ color: 'white' }} onClick={handleToggleOnpremiseS3}>
                            <Typography component="div" variant="h6">
                              {isOnpremiseS3Open ? "Onpremise S3 Config (-)" : "Onpremise S3 Config (+)"}
                            </Typography>
                          </Button>
                        </Box>
                        <Collapse in={isOnpremiseS3Open}>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Box m={2}>
                                <TextField
                                  fullWidth
                                  variant="filled"
                                  type="text"
                                  label="Trovo Bucket ARN"
                                  name="infra_data.onprem_config.onprem_bucket"
                                  value={values.infra_data.onprem_config.onprem_bucket}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start" style={{ marginRight: "0px" }}>
                                        <div style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                          fontWeight: 'bold',
                                        }}>
                                          arn:aws:s3:::
                                        </div>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box m={2}>
                                <TextField
                                  fullWidth
                                  variant="filled"
                                  type="text"
                                  label="Customer AWS Account ID"
                                  name="infra_data.onprem_config.foreign_aws_id"
                                  value={values.infra_data.onprem_config.foreign_aws_id}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box m={2}>
                                <FormControl fullWidth variant="filled">
                                  <InputLabel htmlFor="bucket_location">Bucket Region</InputLabel>
                                  <Select
                                    id="bucket_location"
                                    name="infra_data.onprem_config.bucket_location"
                                    value={values.infra_data.onprem_config.bucket_location}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Bucket Region"
                                  >
                                    <MenuItem value="us-east-2">US East 2</MenuItem>
                                    <MenuItem value="us-east-1">US East 1</MenuItem>
                                    <MenuItem value="us-west-2">US West 2</MenuItem>
                                    <MenuItem value="us-west-1">US West 1</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box m={2}>
                                <FormControl fullWidth variant="filled">
                                  <InputLabel htmlFor="disable_acl">Disable ACL</InputLabel>
                                  <Select
                                    id="disable_acl"
                                    name="infra_data.onprem_config.disable_acl"
                                    value={values.infra_data.onprem_config.disable_acl}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Disable ACL"
                                    defaultValue={false}
                                  >
                                    <MenuItem value={true}>TRUE</MenuItem>
                                    <MenuItem value={false}>FALSE</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              <Box m={2}>
                                <FormControl fullWidth variant="filled">
                                  <InputLabel htmlFor="onprem_service_user_enabled">Onprem Service User</InputLabel>
                                  <Select
                                    id="onprem_service_user_enabled"
                                    name="onprem_service_user_enabled"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Onprem Service User"
                                    defaultValue={false}
                                  >
                                    <MenuItem value={true}>TRUE</MenuItem>
                                    <MenuItem value={false}>FALSE</MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </Grid>
                          </Grid>
                        </Collapse>
                      </Paper>
                    </Grid>
                    <Grid item xs={4}>
                      <Box m={2}>
                        <Paper elevation={3}>
                          {
                            isOnpremiseS3Open && (
                              <FieldArray name="infra_data.onprem_config.foreign_service_users">
                                {({ push, remove }) => (
                                  <Paper elevation={3}>
                                    <Box p={2}>
                                      <Typography variant="h6">Add Foreign AWS User ARNs</Typography>
                                      {values.infra_data.onprem_config.foreign_service_users.map((_, index) => (
                                        <Box key={index} display="flex" alignItems="center" mb={2}>
                                          <Box mr={2} flexBasis="80%">
                                            <TextField
                                              fullWidth
                                              variant="filled"
                                              type="text"
                                              label="ARN"
                                              onBlur={handleBlur}
                                              onChange={(e) => setFieldValue(`infra_data.onprem_config.foreign_service_users.${index}.arn`, e.target.value)}
                                              value={values.infra_data.onprem_config.foreign_service_users[index].arn}
                                              name={`infra_data.onprem_config.foreign_service_users.${index}.arn`}
                                            />
                                          </Box>
                                          <Button variant="outlined" style={{ color: colors.redAccent[500], borderColor: colors.redAccent[500] }} onClick={() => remove(index)}>Delete</Button>
                                        </Box>
                                      ))}
                                      <Button variant="outlined" style={{ color: colors.greenAccent[500], borderColor: colors.greenAccent[500] }} onClick={() => push({ arn: '' })}>
                                        <Box component="span" fontSize="20px">+</Box> Add ARN
                                      </Button>
                                    </Box>
                                  </Paper>
                                )}
                              </FieldArray>
                            )
                          }
                          {
                            isOnpremiseS3Open && values.onprem_service_user_enabled === true && (
                              <FieldArray name="infra_data.onprem_config.onprem_service_users">
                                {({ push, remove }) => (
                                  <Paper elevation={3}>
                                    <Box p={2}>
                                      <Typography variant="h6">Add Service Users</Typography>
                                      {values.infra_data.onprem_config.onprem_service_users.map((_, index) => (
                                        <Box key={index} display="flex" alignItems="center" mb={2}>
                                          <Box mr={2} flexBasis="80%">
                                            <TextField
                                              fullWidth
                                              variant="filled"
                                              type="text"
                                              label="Username"
                                              onBlur={handleBlur}
                                              onChange={(e) => setFieldValue(`infra_data.onprem_config.onprem_service_users.${index}`, e.target.value)}
                                              value={values.infra_data.onprem_config.onprem_service_users[index]}
                                              name={`infra_data.onprem_config.onprem_service_users.${index}`}
                                            />
                                          </Box>
                                          <Button variant="outlined" style={{ color: colors.redAccent[500], borderColor: colors.redAccent[500] }} onClick={() => remove(index)}>Delete</Button>
                                        </Box>
                                      ))}
                                      <Button variant="outlined" style={{ color: colors.greenAccent[500], borderColor: colors.greenAccent[500] }} onClick={() => push('')}>
                                        <Box component="span" fontSize="20px">+</Box> Add Username
                                      </Button>
                                    </Box>
                                  </Paper>
                                )}
                              </FieldArray>
                            )
                          }
                        </Paper>
                      </Box>
                    </Grid>
                  </Grid>
                )
              }

            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Submit S3 Update
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default S3Config;
